import { render } from "./CardPrestation.vue?vue&type=template&id=57f862b4"
import script from "./CardPrestation.vue?vue&type=script&lang=js"
export * from "./CardPrestation.vue?vue&type=script&lang=js"

import "./CardPrestation.vue?vue&type=style&index=0&id=57f862b4&lang=css"
script.render = render

export default script